import {configureStore} from "@reduxjs/toolkit"
import appReducer from "./appReducer"
import companyReducer from "./companyReducer"
import objectReducer from "./objectReducer"
import objectScheduleReducer from "./objectScheduleReducer"
import psLeakDeviceLogReducer from "./psLeakDeviceLogReducer"
import psLeakDeviceLocalLogReducer from "./psLeakDeviceLocalLogReducer"
import psLeakDeviceIndicationReducer from "./psLeakDeviceIndicationReducer"
import objectGroupReducer from "./objectGroupReducer"
import objectGroupScheduleReducer from "./objectGroupScheduleReducer"
import psLeakDeviceReducer from "./psLeakDeviceReducer"
import userGroupReducer from "./userGroupReducer"
import userReducer from "./userReducer"
import attributesVersionReducer from "./attributesVersionReducer"
import securityLogReducer from "./securityLogReducer"
import unregisterPsLeakDeviceReducer from "./unregisterPsLeakDeviceReducer"
import uinListReducer from "./uinListReducer"

export const store = configureStore({
    reducer: {
        appReducer,
        companyReducer,
        objectReducer,
        objectScheduleReducer,
        psLeakDeviceLogReducer,
        psLeakDeviceLocalLogReducer,
        psLeakDeviceIndicationReducer,
        objectGroupReducer,
        objectGroupScheduleReducer,
        psLeakDeviceReducer,
        userGroupReducer,
        userReducer,
        attributesVersionReducer,
        securityLogReducer,
        unregisterPsLeakDeviceReducer,
        uinListReducer,
    },
})

export type StateType = ReturnType<typeof store.getState>
